import type { DeepRequired } from '../fixtures.types'

const caseDetailsFlagFixture: DeepRequired<CaseDetailsFlag> = {
  __typename: 'CaseDetailsFlag',
  flag_id: 'TEST_FLAG_ID',
  flag_type: 'FLAG_MANUAL_REVIEW',
  created_at: null,
  reviews: [],
}

export default caseDetailsFlagFixture
